import React, { Component } from 'react';
import {
  Select, FormControl, MenuItem, Grid, Button,
} from '@material-ui/core';
import '../../css/ivrs/ivrsModal.scss';
import ModalHOC from '../common/Modal/index';

export default class SelectPricePlanModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClose = () => {
    const { onClose } = this.props;
    onClose(false);
  };

  render() {
    const { showModal } = this.props;
    return (
      <React.Fragment>
        <ModalHOC
          isOpen={showModal}
          titleContent="Subscription signup form"
          customContent="select-plan-modal"
          onClose={this.handleClose}
          footerComponent={<Button>Sign up</Button>}
        >
          <div className="selectController btn">
            <Grid container>
              <Grid item xs={12}>
                <span>Showing Prices For</span>
                <FormControl className="formControl inputHead coloredForms inputFullWidth">
                  <Select
                    disableUnderline
                    name="dashboard-user"
                    className="selectEmpty modalDropdown"
                    inputProps={{ 'aria-label': 'user' }}
                    //    value={satellitesSource}
                    displayEmpty
                    //  onChange={ev => this._handleSatelliteSource(ev)}
                  >
                    <MenuItem>Select</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <span>Plans</span>
                <FormControl className="formControl inputHead coloredForms inputFullWidth">
                  <Select
                    disableUnderline
                    name="dashboard-user"
                    className="selectEmpty modalDropdown"
                    inputProps={{ 'aria-label': 'user' }}
                    //    value={satellitesSource}
                    displayEmpty
                    //  onChange={ev => this._handleSatelliteSource(ev)}
                  >
                    <MenuItem>Select</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <span>No of Districts/Leads</span>
                <FormControl className="formControl inputHead coloredForms inputFullWidth">
                  <Select
                    disableUnderline
                    name="dashboard-user"
                    className="selectEmpty modalDropdown"
                    inputProps={{ 'aria-label': 'user' }}
                    //    value={satellitesSource}
                    displayEmpty
                    //  onChange={ev => this._handleSatelliteSource(ev)}
                  >
                    <MenuItem>Select</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <div className="price-box">
            <p>Price for 0-10 districts for strategic reports $10 (one time)</p>
            <h1>$10 (one time)</h1>
          </div>
        </ModalHOC>
      </React.Fragment>
    );
  }
}
